import React from 'react'
import styled from 'styled-components'

import Header from './Header'
import ButtonGroup, { StyledButtonAnchor, StyledButtonLink } from '../Home/ButtonGroup'
import Footer from './Footer'
import Modal from '../Modal'
import { StyledButton } from '../Home/StyledButton'

import Facebook from '../visuals/social/Facebook'
import Instagram from '../visuals/social/Instagram'
import Twitter from '../visuals/social/Twitter'

import { css } from 'styled-components'

const sizes = {
  phone_small: 320,
  phone: 480,
  phone_landscape: 670,
  tablet: 768,
  tablet_landscape: 1024,
  desktop: 1170,
  desktop_large: 1280
}

// iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = sizes[label] / 16
  accumulator[label] = (...args) => css`
    @media (max-width: ${emSize}em) {
      ${css(...args)}
    }
  `
  return accumulator
}, {})

const Wrap = styled.div`

`

const Hero = styled.section`
  min-height: 100vh;
  /*height: 52.8vw;*/
  background: url(${process.env.PUBLIC_URL}/img/mountain.jpg) no-repeat;
  background-position: 53% 50%;
  background-size: cover;

  text-align: center;
`

const Headline = styled.div`
  display: inline-block;
  margin: 0 auto;
  margin-top: 7rem;
  padding: 0 20px;

  text-align: left;
  font-family: 'Source Sans Pro';
  font-weight: bold;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;



  div {
    font-size: 1rem;
    line-height: 80%;
    margin-bottom: -10px;
    margin-left: 1px;
    letter-spacing: 3px;

    background: radial-gradient(circle at center, rgba(255,255,255,1) 0%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,0) 115%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  h1 {
    margin: 0;
    font-size: 3.5rem;
    line-height: 4rem;
    letter-spacing: 13px;

    background: radial-gradient(circle at center, rgba(255,255,255,1) 0%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,0) 115%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media screen and (max-width: 678px) {
    & {
      margin-bottom: 7rem;
    }
  }

`

const Subtitle = styled.p`
  margin: 0;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-weight: normal;
  color: ${props => props.color ? props.color : '#fff'};
  line-height: 1.5rem;
`

const Margin = styled.div`
  margin: ${props => props.margin};
`

const About = styled.section`
  background: #fff;
  padding: 3.5rem 20px;
  text-align: center;
`

const Photo = styled.img`
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
`

const PhotoCaption = styled.div`
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  margin-left: 1.5rem;

  h1 {
    font-family: 'Source Sans Pro';
    font-size: 2rem;
    line-height: 2.5rem;
    color: #232323;
    text-transform: uppercase;
  }

  p {
    font-family: 'Source Sans Pro';
    font-size: 1rem;
    line-height: 1.5rem;
    color: #000;
  }

  @media screen and (max-width: 675px) {
    & {
      margin: 0;
    }
  }
`

const InlineImages = styled.div`
  margin: 0.5rem 0;
  & > * {
    display: inline-block;
    margin: 0.5rem;
    vertical-align: top;
  }
`

const CtaButtons = styled.div`
a + button
{
  margin-left: 1rem;
}
`

const Social = styled.div`
  color: white;
  h5
  {
    font-weight: 400;
    display: inline-block;
    line-height: 2rem;
    color: #C4C4C4;
    margin-right: 2rem;
    font-size: 24px;
	  line-height: 32px;
    ${media.phone_landscape`
      width: 100%;
      margin-bottom: 1rem;
      margin-right: 0;
    `}
  }
  a:not(:first-of-type)
  {
    margin-left: 2rem;
  }
  a
  {
    display: inline-block;
    vertical-align: middle;
  }
`
const Reached = styled.span`
  font-weight: bold;
  color: white;
`

class Landing extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };
  }

  toggleModal = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <Wrap>
        <Modal show={this.state.isOpen}
          onClose={this.toggleModal}></Modal>
        <Hero>
          <Header />

          <Headline>
            <div>The</div>
            <h1>Urdu Audio Bible</h1>
          </Headline>
          <Subtitle>
            Brought to you by <strong>God’s Vision Ministry</strong>
          </Subtitle>

          <Margin margin='1rem'>
            <CtaButtons>
              <StyledButtonAnchor variation="transparent" href="https://www.gvm.website/make-a-donation">Give now</StyledButtonAnchor>
              <StyledButton onClick={this.toggleModal}>Sign In</StyledButton>
            </CtaButtons>
          </Margin>

          <Margin margin='7.5rem 0 0 0'>
            <Subtitle>Also available on</Subtitle>
            <InlineImages>
              <a href="https://itunes.apple.com/nz/app/the-audio-urdu-bible/id1118776210"><img src={process.env.PUBLIC_URL+'/img/app-store.png'} /></a>
              <a href="https://play.google.com/store/apps/details?id=com.audiobible.theaudiourdubible" target="_blank"><img src={process.env.PUBLIC_URL+'/img/google-play.png'} /></a>
            </InlineImages>
          </Margin>

          <Margin margin='3rem 0 0 0'/>
          <Social>
            <h5>We have reached <Reached>936575</Reached>&nbsp;people</h5>
            <a href="https://www.facebook.com/profile.php?id=100004008288371"><Facebook width="29px" height="28px"></Facebook></a>
          </Social>

        </Hero>

        <About>
          <Photo src={process.env.PUBLIC_URL+'/img/family.jpg'} />
          <PhotoCaption>
            <h1>A message from our founder</h1>
            <p>
              We would like thank you for all for your support, kind words and prayers.<br />
              We have faith that only The Holy Bible can change your life. <br />
              The Holy Bible is the Word of the living God.<br />
              May God bless you today and always for being a friend and vital part of the Church family.<br /><br />
              <strong>Thank You.</strong>
            </p>
          </PhotoCaption>
        </About>

        <Footer />
      </Wrap>
    )
  }
}

export default Landing



// WEBPACK FOOTER //
// ./src/components/Landing/index.js